/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';
export const YCombinatorIconConfig = {
  name: 'YCombinatorIcon',
  height: 512,
  width: 448,
  svgPath: 'M448 32v448H0V32h448zM236 287.5L313.5 142h-32.7L235 233c-4.7 9.3-9 18.3-12.8 26.8L210 233l-45.2-91h-35l76.7 143.8v94.5H236v-92.8z',
  yOffset: '',
  xOffset: '',
  transform: ''
};
export default createIcon(YCombinatorIconConfig);